import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/argon-design-system.css';
import 'swiper/swiper-bundle.css';

import 'remixicon/fonts/remixicon.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import 'moment/locale/id';

import App from './App';
import * as serviceWorker from './serviceWorker';
// without this line it didn't work
moment.locale('id');

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
